export enum MutationTypes {
    SET_LOGS = 'logs-module/set-logs',
    SET_LOGS_FOR_CSV = 'logs-module/set-logs-for-csv',
    SET_LOGS_META = 'logs-module/set-logs-meta',
}
